import React from 'react';
import SSMCheckBox from '../ssm-checkbox/ssm-checkbox';
import SSMRadioButton from '../ssm-radio-button/ssm-radio-button';

const SelectionOption = (props) => {
  const { confirmAllCheckBoxChecked, onCheckBoxStatusChanged,
    confirmAllCheckBoxLabel, confirmAllCheckBoxDesc,
    confirmAllCheckBoxId, radioButtonOptions, iconType } = props;
  const radioButtons = (iconType !== 'checkBox') ? radioButtonOptions.map(radioButtonOption => (
    <div key={radioButtonOption.radioButtonId} className="col-md-12 col-sm-12">
      <SSMRadioButton
        radioButtonId={radioButtonOption.radioButtonId}
        radioButtonLabel={radioButtonOption.radioButtonLabel}
        radioButtonDesc={radioButtonOption.radioButtonDesc}
        radioButtonChecked={radioButtonOption.radioButtonChecked}
        onRadioButtonCallBackActionWithToggle={radioButtonOption.onRadioButtonCallBackActionWithToggle}
      />
    </div>
  )) : '';

  return (
    <React.Fragment>
      {
        iconType === 'checkBox' ?
          <SSMCheckBox
            checkBoxId={confirmAllCheckBoxId}
            checkBoxLabel={confirmAllCheckBoxLabel}
            checkBoxDesc={confirmAllCheckBoxDesc}
            checkBoxChecked={confirmAllCheckBoxChecked}
            onCheckBoxStatusChanged={onCheckBoxStatusChanged}
          />
          : (
            <div className="row selection-option-container">
              {radioButtons}
            </div>
          )
      }
    </React.Fragment>
  );
};

export default SelectionOption;
